<template>
  <div>
    <el-button type="primary" @click="handleAdd">新增</el-button>
    <el-button type="primary" @click="fetchData">刷新</el-button>
    <el-button type="primary" @click="showTicketFlowChart">查看流程图</el-button>
    
    <el-table :data="tableData" border>
      <el-table-column prop="name" align="center" label="类型名称" width="120" />
      <el-table-column prop="parent_name" align="center" label="父级类型" width="120"/>
      <el-table-column label="操作" align="center" width="820">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" @click="showTicketHead(scope.row)">头信息</el-button>
          <el-button size="mini" @click="showTicketLineHead(scope.row)">内容体</el-button>
          <el-button size="mini" @click="showTicketProcess(scope.row)">流程</el-button>
          <el-button size="mini" @click="showTicketAction(scope.row)">提交后流转分配</el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="handleDelete(scope.row)"
            :disabled="hasChildren(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="父级类型">
          <el-select v-model="form.parentId" clearable>
            <el-option
                v-for="item in parentOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="`编辑${currentRow.name}头信息`" :visible.sync="isShowTicketHead">
      <TicketHead v-if="isShowTicketHead" :typeId="currentRow.id" :typeName="currentRow.name" />
    </el-dialog>
    <el-dialog :title="`编辑${currentRow.name}头信息`" :visible.sync="isShowTicketLineHead">
      <TicketLineHead v-if="isShowTicketLineHead" :typeId="currentRow.id" :typeName="currentRow.name" />
    </el-dialog>
    <el-dialog :title="`编辑${currentRow.name}流程`" :visible.sync="isShowTicketProcess">
      <TicketProcess v-if="isShowTicketProcess" :typeId="currentRow.id" :typeName="currentRow.name" />
    </el-dialog>
    <el-dialog :title="`编辑${currentRow.name}提交后流转分配`" :visible.sync="isShowTicketAction">
      <TicketAction v-if="isShowTicketAction" :typeId="currentRow.id" :typeName="currentRow.name" />
    </el-dialog>
    <el-dialog :title="`查看流程图`" :visible.sync="isShowTicketFlowChart">
      <TicketFlowChart />
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from "@/utils/requestTicket";
import TicketHead from './TicketHead.vue'
import TicketLineHead from './TicketLineHead.vue'
import TicketProcess from './TicketProcess.vue'
import TicketAction from './TicketAction.vue'
import TicketFlowChart from './TicketFlowChart.vue'

export default {
  components: {
    TicketHead,
    TicketLineHead,
    TicketProcess,
    TicketAction,
    TicketFlowChart
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      isShowTicketHead:  false,
      isShowTicketLineHead:  false,
      isShowTicketProcess: false,
      isShowTicketAction: false,
      isShowTicketFlowChart: false,
      dialogTitle: '新增',
      form: {
        id: null,
        name: '',
        parentId: null
      },
      currentRow: {},
      rules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    parentOptions() {
      return this.tableData.filter(item => !item.parentId)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        const res = await requestTicket.post('/Ticketing/ticket-type/findAll')
        this.tableData = res.data.map(item => ({
          ...item,
          parent_name: this.getParentName(item.parentId,res.data)
        }))
      } catch (error) {
        console.error(error)
      }
    },
    getParentName(parentId,data) {
      const parent = data.find(item => item.id === parentId)
      return parent ? parent.name : ''
    },
    hasChildren(id) {
      return this.tableData.some(item => item.parentId === id)
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.form = { id: null, name: '', parentId: null }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑'
      this.form = { ...row }
      this.dialogVisible = true
    },
    showTicketHead(row) {
      this.currentRow = row
      this.isShowTicketHead = true
    },
    showTicketLineHead(row) {
      this.currentRow = row
      this.isShowTicketLineHead = true
    },
    showTicketProcess(row) {
      this.currentRow = row
      this.isShowTicketProcess = true
    },
    showTicketAction( row) {
      this.currentRow = row
      this.isShowTicketAction = true
    },
    showTicketFlowChart() {
      this.isShowTicketFlowChart = true
    },
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await requestTicket.post('/Ticketing/ticket-type/save', this.form)
            this.dialogVisible = false
            this.fetchData()
          } catch (error) {
            console.error(error)
          }
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该类型？', '提示', { type: 'warning' })
        await requestTicket.delete(`/Ticketing/ticket-type/${row.id}`)
        this.fetchData()
      } catch (error) {
        if (error !== 'cancel') console.error(error)
      }
    }
  }
}
</script>